import { Link } from 'react-router-dom';

export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#0A0A0A]">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d86c2f18f2708de5fa32c7ff9f9f1526.jpg"
          alt="AlphaOps AI hero background"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/40 to-[#0A0A0A]"></div>
      </div>

      {/* Accent glow */}
      <div className="absolute top-1/3 right-1/4 w-[600px] h-[600px] rounded-full bg-[#38C6F5]/5 blur-[120px] pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1360px] mx-auto px-8 md:px-16 pt-32 pb-24">
        <div className="max-w-[860px]">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-8">
            <span className="inline-block w-8 h-px bg-[#38C6F5]"></span>
            <span className="text-[#38C6F5] text-xs uppercase tracking-[3px] font-medium">
              AI Operations Consulting
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-[84px] font-extralight text-white leading-[1.05] tracking-tight mb-8">
            Smarter Systems.<br />
            <span className="font-semibold">Stronger Margins.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-[#A0A0A0] leading-relaxed max-w-[620px] mb-12">
            Most service businesses don't struggle with lead generation — they struggle with response time, follow-up, and conversion. AlphaOps AI fixes the operational layer so every opportunity is captured, qualified, and converted.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={() => handleScroll('cta')}
              className="bg-[#38C6F5] text-black text-sm font-semibold px-8 py-4 rounded-full hover:bg-white transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              Schedule Consultation
              <i className="ri-arrow-right-line"></i>
            </button>
            <Link
              to="/industries"
              className="border border-white/20 text-white text-sm px-8 py-4 rounded-full hover:border-white/50 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              View Industries
            </Link>
          </div>
        </div>

        {/* Stats Row */}
        <div className="mt-24 pt-10 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '94%', label: 'Response Rate' },
            { value: '3.2x', label: 'Average ROI' },
            { value: '24/7', label: 'System Coverage' },
            { value: '< 60s', label: 'Lead Response Time' },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-3xl md:text-4xl font-light text-white mb-1">{stat.value}</div>
              <div className="text-[#707070] text-xs uppercase tracking-widest">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
